/* @flow */
import { List } from 'immutable';
import type { WhitelistEntryType } from './types';
import * as ActionTypes from './action-types.js';

/* Fetches all whitelist entries */
export const fetchCompanyWhitelist = (): Object => ({ type: ActionTypes.FETCH_WHITELIST_PAGE });

/* Handles save new entry and edit entry*/
export const saveWhitelistEntry = (whitelistEntry: WhitelistEntryType): Object => ({
  type: ActionTypes.SAVE_WHITELIST_ENTRY,
  payload: whitelistEntry, 
});

export const saveWhitelistEntries = (texts: List<string>): Object => ({
  type: ActionTypes.SAVE_WHITELIST_ENTRIES,
  payload: texts,
});

/* Delete by guid */
export const deleteWhitelistEntry = (whitelistEntry: WhitelistEntryType): Object => ({
  type: ActionTypes.DELETE_WHITELIST_ENTRY,
  payload: whitelistEntry,
});

export const clearWhitelist = (): Object => ({
  type: ActionTypes.CLEAR_WHITELIST,
});

export const updateFilters = (payload: Object, field?: string) => ({
  type: ActionTypes.UPDATE_PAGE_FILTERS,
  payload,
  field,
});

export const resetFilters = () => ({ type: ActionTypes.RESET_PAGE_FILTERS });



// WEBPACK FOOTER //
// ./src/app/modules/company-whitelist/actions.js